import { MyActiveOrganization } from '@/helpers/my-account-helper'
/**
 * @param caseId
 * @param patientId
 */
export function getCaseRouterLink(caseId, patientId) {
  if (MyActiveOrganization.type === 'RESEARCH' || !patientId) {
    return {
      name: 'case-detail',
      params: { orgId: MyActiveOrganization.id, caseId: caseId }
    }
  } else
    return {
      name: 'patient-case',
      params: {
        orgId: MyActiveOrganization.id,
        caseId: caseId,
        patientId: patientId
      }
    }
}

/**
 * @param trialId
 * @param userNotificationRecordId
 * @param statusFilter
 */
export function getTrialsHomeLink(trialId, userNotificationRecordId, statusFilter) {
  return {
    name: 'trials',
    params: {
      userNotificationRecordId: userNotificationRecordId,
      trialId: trialId,
      orgId: MyActiveOrganization.id
    },
    query: {
      trialId: trialId,
      statusFilter: statusFilter
    }
  }
}
